/* The Rugs — lightweight wishlist (localStorage, no app/account needed).
   - Toggle buttons: [data-wishlist-toggle][data-wishlist-handle]
   - Header opener:  [data-wishlist-open]  + count badge [data-wishlist-count]
   - Drawer:         #WishlistDrawer with [data-wishlist-body]
   Product data for the drawer is fetched from /products/{handle}.js (no theme dependency). */
(function () {
  'use strict';
  var KEY = 'therugs_wishlist_v1';

  function get() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function save(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function has(h) { return get().indexOf(h) > -1; }
  function toggle(h) {
    var a = get(), i = a.indexOf(h);
    if (i > -1) a.splice(i, 1); else a.unshift(h);
    save(a); refresh();
    return a.indexOf(h) > -1;
  }

  function updateCount() {
    var n = get().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.style.display = n ? '' : 'none';
    });
  }
  function syncButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var on = has(btn.getAttribute('data-wishlist-handle'));
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Save to wishlist');
    });
  }
  function refresh() { updateCount(); syncButtons(); if (isOpen()) renderDrawer(); }

  /* ── drawer ── */
  function drawer() { return document.getElementById('WishlistDrawer'); }
  function isOpen() { var d = drawer(); return d && d.classList.contains('is-open'); }
  function openDrawer() {
    var d = drawer(); if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('wishlist-open');
    renderDrawer();
  }
  function closeDrawer() {
    var d = drawer(); if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('wishlist-open');
  }
  function money(cents) {
    try { return (cents / 100).toLocaleString('en-GB', { style: 'currency', currency: 'GBP' }); }
    catch (e) { return '£' + (cents / 100).toFixed(2); }
  }
  function imgUrl(u) {
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=200';
  }
  function renderDrawer() {
    var body = document.querySelector('#WishlistDrawer [data-wishlist-body]');
    if (!body) return;
    var items = get();
    if (!items.length) {
      body.innerHTML = '<p class="wishlist-drawer__empty">Your wishlist is empty.<br>Tap the bookmark on any rug to save it here.</p>';
      return;
    }
    body.innerHTML = '<p class="wishlist-drawer__loading">Loading…</p>';
    Promise.all(items.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (prods) {
      var html = prods.filter(Boolean).map(function (p) {
        var img = imgUrl(p.featured_image || (p.images && p.images[0]));
        return '<div class="wishlist-card">'
          + '<a class="wishlist-card__media" href="/products/' + p.handle + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>'
          + '<div class="wishlist-card__body">'
          + '<a class="wishlist-card__title" href="/products/' + p.handle + '">' + p.title + '</a>'
          + '<div class="wishlist-card__price">' + money(p.price) + '</div>'
          + '<div class="wishlist-card__actions">'
          + '<a class="wishlist-card__view" href="/products/' + p.handle + '">View product</a>'
          + '<button type="button" class="wishlist-card__remove" data-wishlist-remove data-handle="' + p.handle + '" aria-label="Remove">Remove</button>'
          + '</div></div></div>';
      }).join('');
      body.innerHTML = html || '<p class="wishlist-drawer__empty">Your wishlist is empty.</p>';
    });
  }

  /* ── delegated events ── */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-wishlist-toggle]');
    if (t) { e.preventDefault(); e.stopPropagation(); toggle(t.getAttribute('data-wishlist-handle')); return; }
    if (e.target.closest('[data-wishlist-open]')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-wishlist-close]') || e.target.classList.contains('wishlist-drawer__overlay')) { closeDrawer(); return; }
    var rm = e.target.closest('[data-wishlist-remove]');
    if (rm) { e.preventDefault(); toggle(rm.getAttribute('data-handle')); return; }
  });
  document.addEventListener('keyup', function (e) { if (e.key === 'Escape' && isOpen()) closeDrawer(); });

  function init() { updateCount(); syncButtons(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  // B2: a colour swap re-points a card's bookmark (swatch-group.js); a filter/sort re-render brings new buttons
  document.addEventListener('wishlist:sync', syncButtons);
  document.addEventListener('collection:reloaded', syncButtons);
})();
